import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Constants } from '@app/common/constants';
import { HttpHelper } from '@app/common/http-helper';
import { UserTabComponentConfiguration } from '@app/models/user-tab-configuration';
import { concat, Observable, of, Subject } from 'rxjs';
import { catchError, map, shareReplay, takeUntil, tap } from 'rxjs/operators';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root'
})
export class UserTabComponentConfigurationsService {

  constructor(private http: HttpClient, private cache: CacheService, private httpHelper: HttpHelper) { }

  public readonly cacheKey = 'UserTabComponentConfigurationsService-getUserTabConfig';
  public useCache = true;
  private getUserTabConfig$: Observable<Array<UserTabComponentConfiguration>>;
  private reload$ = new Subject<void>();

  public reload() {
    this.reload$.next();
    this.getUserTabConfig$ = null;
    if (this.useCache) {
      this.cache.removeFromPersistentCache(this.cacheKey);
    }
  }

  getUserTabConfig(): Observable<Array<UserTabComponentConfiguration>> {
    if (this.getUserTabConfig$) {
      return this.getUserTabConfig$;
    } else {
      this.getUserTabConfig$ = this.http.get<Array<UserTabComponentConfiguration>>(`${Constants.API_ENDPOINT}/me/usertabcomponentconfigurations`)
        .pipe(
          map(response => {
            console.log('UserTabComponentConfigurationsService.getUserTabConfig', response);
            return response.map(p => new UserTabComponentConfiguration(p));
          }),
          tap(data => {
            this.useCache && this.cache.set(this.cacheKey, data);
          }),
          catchError(this.httpHelper.handleError({ operation: 'getUserTabConfig', result: new Array<UserTabComponentConfiguration>(), rethrow: true, cacheKey: this.cacheKey })),
          takeUntil(this.reload$),
          shareReplay({ bufferSize: 1, refCount: true }));

      if (this.useCache) {
        const cachedData = this.cache.get<Array<UserTabComponentConfiguration>>(this.cacheKey);
        if (cachedData) {
          return concat(of(cachedData), this.getUserTabConfig$);
        }
      }

      return this.getUserTabConfig$;
    }

  }

  addUserTabConfiguration(userTabConfiguration: UserTabComponentConfiguration): Observable<UserTabComponentConfiguration> {
    return this.http.post<UserTabComponentConfiguration>(`${Constants.API_ENDPOINT}/me/usertabcomponentconfigurations`, userTabConfiguration)
      .pipe(
        map(response => {
          // console.log(`added result: `);
          // console.log(response);
          this.reload();
          return new UserTabComponentConfiguration(response);
        }),
        catchError(this.httpHelper.handleError({ operation: 'addUserTabConfiguration', result: new UserTabComponentConfiguration(), rethrow: true })));
  }

  updateUserTabConfigurations(userTabConfigurations: Array<UserTabComponentConfiguration>): Observable<any> {
    return this.http.put<Array<UserTabComponentConfiguration>>(`${Constants.API_ENDPOINT}/me/usertabcomponentconfigurations`, userTabConfigurations)
      .pipe(
        tap(response => {
          // console.log(`updated results: `);
          // console.log(response);
          this.reload();
        }),
        catchError(this.httpHelper.handleError({ operation: 'updateUserTabConfigurations', result: new Array<UserTabComponentConfiguration>(), rethrow: true })));
  }

  updateUserTabConfiguration(id: number, userTabConfiguration: UserTabComponentConfiguration): Observable<any> {
    return this.http.put<Array<UserTabComponentConfiguration>>(`${Constants.API_ENDPOINT}/me/usertabcomponentconfigurations/${id}`, userTabConfiguration)
      .pipe(
        tap(response => {
          // console.log(`updated result: `);
          // console.log(response);
          this.reload();
        }),
        catchError(this.httpHelper.handleError({ operation: 'updateUserTabConfiguration', result: new UserTabComponentConfiguration(), rethrow: true })));
  }
}
